const $ = jQuery;
const _window = $(window);
const Menu = {
	$dom: {
		container: $('#site-navigation'),
		container_flv: $('.header-my-flv-mobile'),
		menu_toggle: $('.menu-toggle'),
		menu_toggle_flv: $('.menu-toggle-flv'),
		body: $('body'),
		menu: undefined,
		menu_flv: undefined,
		links: undefined,
		links_flv: undefined,
		sub_menus: undefined,
		sub_menus_flv: undefined,
	},
	vars: {
		activated_screen_resolution: 1023,
		show_arrows_on_desktop: false,
	},
	initDom: function () {
		Menu.$dom.menu = Menu.$dom.container.find('ul').eq(0);
		Menu.$dom.links = Menu.$dom.menu.find('a');
		Menu.$dom.sub_menus = Menu.$dom.menu.find('ul');
		Menu.$dom.menu_flv = Menu.$dom.container_flv.find('ul').eq(0);
		Menu.$dom.links_flv = Menu.$dom.menu_flv.find('a');
		Menu.$dom.sub_menus_flv = Menu.$dom.menu_flv.find('ul');
	},
	appendArrows: function () {
		if (
			_window.width() <= Menu.vars.activated_screen_resolution ||
			Menu.vars.show_arrows_on_desktop
		) {
			var items_has_children = Menu.$dom.container.find(
				'li.menu-item-has-children'
			);

			items_has_children.each(function () {
				if ($(this).find('.arrow-toggle').length > 0) return;

				var $parent = this;
				var $arrow = $(
					'<span class="arrow-toggle"><svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.69531 16.3964L14.0771 11.0146L8.69531 5.63281" stroke="#1E1E1E" stroke-width="2.15271" stroke-linecap="round" stroke-linejoin="round"/></svg></span>'
				);

				$(this).prepend($arrow);

				$arrow.on('click', function () {
					$($parent).toggleClass('expandeds');
					$($parent).find('> .sub-menu').slideToggle(500);
				});
			});
		} else {
			$('.arrow-toggle').remove();
		}
	},
	appendArrowsFlv: function () {
		if (
			_window.width() <= Menu.vars.activated_screen_resolution ||
			Menu.vars.show_arrows_on_desktop
		) {
			var items_has_children = Menu.$dom.container_flv.find(
				'li.menu-item-has-children'
			);

			items_has_children.each(function () {
				if ($(this).find('.arrow-toggle').length > 0) return;

				var $parent = this;
				var $arrow = $(
					'<span class="arrow-toggle"><svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.69531 16.3964L14.0771 11.0146L8.69531 5.63281" stroke="#1E1E1E" stroke-width="2.15271" stroke-linecap="round" stroke-linejoin="round"/></svg></span>'
				);

				$(this).prepend($arrow);

				$arrow.on('click', function () {
					$($parent).toggleClass('expandeds');
					$($parent).find('> .sub-menu').slideToggle(500);
				});
			});
		} else {
			$('.arrow-toggle').remove();
		}
	},

	toggleMenuFlv: function () {
		Menu.$dom.menu_toggle_flv.on('click', function (e) {
			Menu.$dom.menu_toggle_flv.toggleClass('is-active');
			Menu.$dom.body.toggleClass('menu-active-flv');
			Menu.$dom.container_flv.toggleClass('toggled');
			if (Menu.$dom.body.hasClass('page-template-homepage-tpl')) {
				$('html, body').animate(
					{
						scrollTop: $('#site-header').offset().top,
					},
					400
				);
			}
			e.stopPropagation();
		});
	},
	toggleMenu: function () {
		Menu.$dom.menu_toggle.on('click', function (e) {
			Menu.$dom.menu_toggle.toggleClass('is-active');
			Menu.$dom.body.toggleClass('menu-active');
			Menu.$dom.container.toggleClass('toggled');
			if (Menu.$dom.body.hasClass('page-template-homepage-tpl')) {
				$('html, body').animate(
					{
						scrollTop: $('#site-header').offset().top,
					},
					400
				);
			}
			e.stopPropagation();
		});
	},
	closeMenu: function () {
		if ($(this).attr('href') != '#' && $(this).attr('href') != '') {
			Menu.$dom.body.removeClass('menu-active');
			Menu.$dom.body.removeClass('menu-active-flv');
			Menu.$dom.menu_toggle.removeClass('is-active');
			Menu.$dom.menu_toggle_flv.removeClass('is-active');
			Menu.$dom.container.removeClass('toggled');
			Menu.$dom.container_flv.removeClass('toggled');
		}
	},
	bindScrollResize: function () {
		_window.on('resize', function () {
			Menu.appendArrows();
			Menu.appendArrowsFlv();
		});
	},
	bindClicks: function () {
		$(document).on('click', Menu.closeMenu);
		Menu.$dom.links.on('click', Menu.closeMenu);
		Menu.$dom.links_flv.on('click', Menu.closeMenu);
		Menu.toggleMenu();
		Menu.toggleMenuFlv();
		Menu.$dom.container.find('> div').click(function (e) {
			e.stopPropagation();
		});
		Menu.$dom.container_flv.find('> div').click(function (e) {
			e.stopPropagation();
		});
	},
	init: function () {
		Menu.initDom();
		Menu.appendArrows();
		Menu.appendArrowsFlv();
		Menu.bindClicks();
		Menu.bindScrollResize();
	},
};
export default Menu;
